import React from "react"
import "./index.scss"

/**
 *
 * @param {Any} checked - Value to be checked, true, false or "undefined"
 * @param {Boolean} disabled - If true, the checkbox will be disabled
 * @param {Function} onChange - Function to be called when the checkbox is changed, response the value of the checkbox
 * @returns
 */
function Checkbox({
  checked = false,
  disabled = false,
  required = false,
  onChange = (checked = false) => {},
  ...props
}) {
  const Check = () => (
    <svg
      width="9"
      height="7"
      viewBox="0 0 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.125 6.5125L0 3.3875L0.88125 2.50625L3.125 4.74375L7.86875 0L8.75 0.8875L3.125 6.5125Z"
        fill="#FFF"
      />
    </svg>
  )

  const Line = () => (
    <svg
      width="9"
      height="7"
      viewBox="0 0 9 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="3" width="9" height="1.2" fill="#FFF" />
    </svg>
  )

  return (
    <div
      className={disabled ? "checkbox checkbox--disabled" : "checkbox"}
      onClick={() => onChange(!checked)}
      {...props}
    >
      <input type="checkbox" checked={checked} onChange={() => {}} />
      <span
        className={
          checked !== false
            ? "checkbox__checkmark checkbox__checkmark--checked"
            : "checkbox__checkmark"
        }
      >
        {checked === "undefined" && <Line />}
        {checked === true && <Check />}
      </span>
    </div>
  )
}

export default Checkbox
